import Papa from 'papaparse';

export function parseCSV(file) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        resolve(results.data);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}

export function extractUniqueBuildings(csvData) {
  const buildingMap = new Map();
  
  csvData.forEach((row) => {
    const address = row.buildingAddress?.trim();
    if (!address) return;
    
    if (!buildingMap.has(address)) {
      buildingMap.set(address, {
        buildingAddress: address,
        buildingName: row.buildingName?.trim() || '',
        totalUnits: row.totalUnits || 0,
        yearBuilt: row.yearBuilt || null,
        units: [],
      });
    }
    
    const building = buildingMap.get(address);
    if (row.unitNumber) {
      building.units.push({
        unitNumber: row.unitNumber,
        bedrooms: row.bedrooms || 0,
        bathrooms: row.bathrooms || 0,
        sqft: row.sqft || null,
        currentRent: row.currentRent || 0,
        amenities: row.amenities || '',
      });
    }
  });
  
  return Array.from(buildingMap.values());
}

export async function geocodeAddress(address, accessToken) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_NODE_URL}/agent/geocodedAddress`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ address }),
      }
    );

    if (!response.ok) {
      throw new Error(`Geocoding failed: ${response.statusText}`);
    }

    const data = await response.json();
    return {
      longitude: data.address_longitude,
      latitude: data.address_latitude,
      address: data.address,
    };
  } catch (error) {
    console.error('Error geocoding address:', error);
    throw error;
  }
}

export async function checkBoundary(coordinates, accessToken) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_NODE_URL}/boundary/check`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ coordinates }),
      }
    );

    if (!response.ok) {
      throw new Error(`Boundary check failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data.data.isWithinKansasCity;
  } catch (error) {
    console.error('Error checking boundary:', error);
    throw error;
  }
}

export async function processBuildings(buildings, accessToken, onProgress) {
  const processedBuildings = [];
  
  for (let i = 0; i < buildings.length; i++) {
    const building = buildings[i];
    
    try {
      if (onProgress) {
        onProgress(i + 1, buildings.length, building.buildingAddress);
      }
      
      const geocodeResult = await geocodeAddress(building.buildingAddress, accessToken);
      const isWithin = await checkBoundary(
        [geocodeResult.longitude, geocodeResult.latitude],
        accessToken
      );
      
      processedBuildings.push({
        ...building,
        coordinates: [geocodeResult.longitude, geocodeResult.latitude],
        longitude: geocodeResult.longitude,
        latitude: geocodeResult.latitude,
        isWithinKansasCity: isWithin,
        geocoded: true,
      });
    } catch (error) {
      console.error(`Error processing building ${building.buildingAddress}:`, error);
      processedBuildings.push({
        ...building,
        coordinates: null,
        longitude: null,
        latitude: null,
        isWithinKansasCity: false,
        geocoded: false,
        error: error.message,
      });
    }
  }
  
  return processedBuildings;
}
